import { normalizeWindAlarmWindowsResponse } from "../components/utility/windAlarmWindows";
import { endpoints } from "./endpoints";
import { authedGet } from "./http";

export const fetchWindAlarmWindowsByScenario = async (projectId, scenario) => {
  const { data } = await authedGet(
    endpoints.apps.dynamicWindProtection(projectId, scenario),
  );
  return normalizeWindAlarmWindowsResponse(data).map((windowItem) => ({
    ...windowItem,
    scenario_name: windowItem.scenario_name || scenario,
  }));
};

export const fetchWindAlarmWindowsForScenarios = async (
  projectId,
  scenarios = [],
) => {
  const results = await Promise.all(
    scenarios.map(async (scenario) => ({
      key: scenario,
      data: await fetchWindAlarmWindowsByScenario(projectId, scenario),
    })),
  );
  return Object.fromEntries(results.map(({ key, data }) => [key, data]));
};
